import Axios from 'axios';
const http = Axios.create({
  withCredentials: true,
});

http.interceptors.response
  .use(
    response => response,
    (error) => {
      
      let isLoginError = false;
      
      if(error.response){
        if (error.response.data && error.response.data.error) {
          isLoginError = error.response.data.error.indexOf("login_failed") != -1
        }
  
        // ステータスコード:401でログインエラー以外の認証エラーの場合はログイン画面に戻る
        if(error.response.status == 401 && !isLoginError){
          const url = window.location.href;
          if(url.indexOf("student_site") != -1){
            // マイページへ
            window.location.href=`https://w2.hamagakuen.jp/login`;
          }else{
            // 教師サイトログイン画面へ
            window.location.href="/#/";
          }
          return;
        }else if(error.response.status == 500){
          if(error.response.data.errors !== undefined && error.response.data.stack !== undefined){
            console.log(error.response.data.errors[0]);
            console.log(error.response.data.stack);
          }
        }
      }
      
      return Promise.reject(error);
    });

export default http;
